/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable max-len */
/* eslint-disable no-empty */
/* eslint-disable no-console */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-async-promise-executor */
/* eslint-disable no-await-in-loop */
import requester from '../../utils/requester';
import config from '../../config';
import offlineDB from '../index';


const syncOfflineEditAnimals = () => new Promise(async (resolve, reject) => {

    // Algorithm of submitting offline editEditAnimals:
    // check offline files, upload them first => update in editEditAnimal
    // check new farm, add them first => update in editEditAnimal
    // send editEditAnimal to the server => delete editEditAnimal from offlineDB
    try {
        const userInfo = await requester.authNeed().contentType('application/json').get(config.serverURL + '/user');
        if (userInfo?.data?.results?.id) {
            const userId = userInfo.data.results.id;

            const offlineEditAnimalsList = await offlineDB.syncEditAnimals.getEditAnimalsList();

            if (offlineEditAnimalsList?.success) {

                if (offlineEditAnimalsList?.data?.length) {

                    // just selected items related to currect user to sync
                    const filteredListByUserId = offlineEditAnimalsList.data.filter(item => item?.userId?.toString() === userId.toString());
                    for (const singleEditAnimal of filteredListByUserId) {

                        const editEditAnimalSaveObject = {}; // to make an editEditAnimal object in required format to submit


                        // upload avatar and save returned url
                        const editEditAnimalAvatarOfflineDBID = singleEditAnimal?.image?.offlineDBID || null;
                        if (editEditAnimalAvatarOfflineDBID) {
                            try {
                                const avatarOnOfflineDB = await offlineDB.files.getFile(editEditAnimalAvatarOfflineDBID);
                                if (avatarOnOfflineDB) {
                                    const blob = avatarOnOfflineDB.file;
                                    const formData = new FormData();
                                    formData.append('fileupload', blob, 'fileupload.jpg');
                                    const uploadResult = await requester.contentType(false).authNeed().post(config.serverURL + '/upload', formData, true);
                                    if (uploadResult?.data?.results?.[0]?.uri) {
                                        const uploadedURL = uploadResult.data.results[0].uri;
                                        editEditAnimalSaveObject.image = uploadedURL;
                                        try {
                                            offlineDB.files.deleteFile(editEditAnimalAvatarOfflineDBID);
                                        }
                                        catch { }
                                    }
                                    else {
                                        // failed to upload file
                                        try {
                                            offlineDB.files.deleteFile(editEditAnimalAvatarOfflineDBID);
                                        }
                                        catch { }
                                    }
                                }
                            }
                            catch { }
                        }


                        // upload attachments and save returned urls array
                        const editEditAnimalAttachmentsList = singleEditAnimal?.attachment || null;
                        if (editEditAnimalAttachmentsList?.length) {
                            const attachmentsList = [];
                            for (const singleAttachment of singleEditAnimal.attachment) {

                                if (singleAttachment?.offlineDBID) {
                                    try {
                                        const fileOnOfflineDB = await offlineDB.files.getFile(singleAttachment.offlineDBID);
                                        if (fileOnOfflineDB?.success) {

                                            const file = fileOnOfflineDB.file;
                                            const formData = new FormData();
                                            formData.append('fileupload', file, file.name);
                                            const uploadResult = await requester.contentType(false).authNeed().post(config.serverURL + '/upload', formData, true);
                                            if (uploadResult?.data?.results?.[0]?.uri) {
                                                attachmentsList.push(uploadResult.data.results[0].uri);
                                                try {
                                                    offlineDB.files.deleteFile(singleAttachment.offlineDBID);
                                                }
                                                catch { }
                                            }
                                            else {
                                                // failed to upload file
                                                try {
                                                    offlineDB.files.deleteFile(singleAttachment.offlineDBID);
                                                }
                                                catch { }
                                            }
                                        }
                                    }
                                    catch (err) { console.log(err) }
                                }
                            }
                            editEditAnimalSaveObject.attachment = attachmentsList;
                        }


                        // check if entered farm is new, then create it
                        const editEditAnimalFarm = singleEditAnimal?.farm || null;
                        if (editEditAnimalFarm?.isNew) {
                            const newFarm = await requester.contentType('application/json').authNeed().post(config.serverURL + '/farms', { name: editEditAnimalFarm.value });
                            if (newFarm?.data?.results?.length) {
                                editEditAnimalSaveObject.farmId = parseInt(newFarm.data.results[0].farmId);
                            }
                            else {
                                // if faild, the most possible reason could be name existence, so add (2) and try again
                                const newFarmNameModified = await requester.contentType('application/json').authNeed().post(config.serverURL + '/farms', { name: editEditAnimalFarm.value + ' (2)' });
                                if (newFarmNameModified?.data?.results?.length) {
                                    editEditAnimalSaveObject.farmId = parseInt(newFarmNameModified.data.results[0].farmId);
                                }
                            }
                        }
                        else {
                            editEditAnimalSaveObject?.farmId && (editEditAnimalSaveObject.farmId = parseInt(editEditAnimalFarm.value));
                        }

                        singleEditAnimal.earTagNo && (editEditAnimalSaveObject.earTagNo = singleEditAnimal.earTagNo);
                        singleEditAnimal.gender && (editEditAnimalSaveObject.gender = singleEditAnimal.gender);
                        singleEditAnimal.name && (editEditAnimalSaveObject.name = singleEditAnimal.name);
                        singleEditAnimal.age && (editEditAnimalSaveObject.age = singleEditAnimal.age.toString());
                        singleEditAnimal.timeOnFarm && (editEditAnimalSaveObject.timeOnFarm = Number(singleEditAnimal.timeOnFarm));
                        singleEditAnimal.dob && (editEditAnimalSaveObject.dob = singleEditAnimal.dob);
                        singleEditAnimal.sire && (editEditAnimalSaveObject.sire = singleEditAnimal.sire);
                        singleEditAnimal.breedId && (editEditAnimalSaveObject.breedId = singleEditAnimal.breedId);
                        singleEditAnimal.deviceMac && (editEditAnimalSaveObject.deviceMac = singleEditAnimal.deviceMac.toString());
                        singleEditAnimal.weight && (editEditAnimalSaveObject.weight = singleEditAnimal.weight + ' grams');
                        singleEditAnimal.groups && (editEditAnimalSaveObject.groups = singleEditAnimal.groups);

                        if (singleEditAnimal.id) {

                            const newEditAnimal = await requester.contentType('application/json').authNeed().put(config.serverURL + '/animals/' + singleEditAnimal.id, editEditAnimalSaveObject);

                            if (newEditAnimal?.data?.results?.affectedRows === 1) {
                                // delete editEditAnimal from offline sync store after submit
                                try {
                                    offlineDB.syncEditAnimals.deleteEditAnimal(singleEditAnimal.offlineId);
                                }
                                catch { reject(); }
                            }
                        }
                        else {
                            reject();
                        }
                    }
                    resolve(); // resolve after loop
                }
                else { resolve(); } // offline editEditAnimals list is empty
            }
            else { reject('error - syncOfflineEditAnimals'); }
        }
        else {
            reject('error - syncOfflineEditAnimals - user not found');
        }
    }
    catch (error) { console.log(error); reject('error - syncOfflineEditAnimals'); }
});

export default syncOfflineEditAnimals;
